/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { mediaPhone } from '../styles/breakpoints';
import { LogoLabelStyles, px, LOGO_PHONE_SCALE } from '../styles/Logo';
import { sharpImageRendering } from '../styles/images';

import LogoImage from './BfB-Logo.svg';

const LOGO_WIDTH = 120;
const LOGO_HEIGHT = 40;
const LOGO_SCALE = 1.28;

export const BFBLogoSmallOnPhone = css({
  [mediaPhone]: {
    width: px(LOGO_WIDTH * LOGO_SCALE * LOGO_PHONE_SCALE),
    height: px(LOGO_HEIGHT * LOGO_SCALE * LOGO_PHONE_SCALE),
    marginTop: '7px',
  },
});

class BFBLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  render() {
    const { className, labelStyles, imageContainerStyles, imageStyles } = this.props;
    const { loaded } = this.state;
    return (
      <article className={className}>
        <div className={css(LogoLabelStyles, labelStyles)}>
          Initiiert und durchgeführt von
        </div>
        <div
          className={css(`
            text-align: right;
          `, imageContainerStyles)}
        >
          <a href="http://www.bundfuerbildung.de" target="_blank" rel="noopener nofollow external">
            <img
              src={LogoImage}
              alt="Bund für Bildung"
              className={css(sharpImageRendering, {
                width: px(LOGO_WIDTH * LOGO_SCALE),
                height: px(LOGO_HEIGHT * LOGO_SCALE),
                marginTop: '2px',
              }, imageStyles)}
              style={{ opacity: loaded ? 1 : 0 }}
              onLoad={() => this.setState({ loaded: true })}
            />
          </a>
        </div>
      </article>
    );
  }
}

BFBLogo.propTypes = {
  className: PropTypes.string,
  labelStyles: PropTypes.any,
  imageContainerStyles: PropTypes.any,
  imageStyles: PropTypes.any,
};

BFBLogo.defaultProps = {
  className: undefined,
  labelStyles: undefined,
  imageContainerStyles: undefined,
  imageStyles: undefined,
};

export default BFBLogo;



// WEBPACK FOOTER //
// ./src/components/BFBLogo/BFBLogo.js